// hooks/useCategories.js
import { useState, useEffect } from 'react';
import axios from 'axios';

export const useCategories = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                setLoading(true);
                setError(null);
                
                // ✅ Corretto: aggiunto /api/ e usato response.data
                const response = await axios.get('/api/categorie-prodotti');
                
                // ✅ Axios usa response.status, non response.ok
                if (response.status !== 200) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                
                // ✅ Axios parsa già il JSON, usa response.data
                const result = response.data;
                
                if (result.success && Array.isArray(result.data)) {
                    const activeCategories = result.data.filter(cat => cat.attiva !== false);
                    const sortedCategories = activeCategories.sort((a, b) => a.id - b.id);
                    setCategories(sortedCategories);
                } else {
                    setCategories([]);
                }
                
            } catch (err) {
                console.error('Errore categorie:', err);
                setError(err.message);
                setCategories([]);
            } finally {
                setLoading(false);
            }
        };
        
        fetchCategories();
    }, []);
    
    return { 
        categories, 
        loading, 
        error 
    };
};
